// @flow
import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';

export default function syncLogReducer(state = initialState.syncLog, ourClientId: number, action) {

    switch (action.type) {
        case types.GOT_NUM_SYNC_ITEMS: {
            return {
                initialized: true, 
                numSyncItems: action.numSyncItems
            };
        }
        default:
            return (state);
    }
}

